<template>
  <div class="index">
    <section
      class="banner-box"
      :style="{ backgroundImage: 'url(' + pageConfig.searchPhoto + ')' }"
    >
      <div class="search-block">
        <h2 class="banner-title">
          Explore nearby restaurants, Discover food you love <br />
          Starting with All Eat
        </h2>
        <div class="search-box">
          <input
            type="text"
            v-model="keywords"
            placeholder="Enter your postcode or restaurant name"
            @input="inputNow"
            @keyup="inputNow"
          />
          <button class="search-btn" @click="inputNow">
            <img src="@/assets/images/search.png" alt="search-img" />
          </button>
          <!-- 搜索结果内容 -->
          <div :class="['expand-box', { 'expand-box-active': keywords }]">
              <div
                class="search-item"
                v-for="(item, ind) in resultList"
                :key="ind"
                @click="normalSearch(item)"
              >
                <span>{{ item.content }}</span>
                <i class="el-icon-loading" v-if="itemLoading==item.place_id"></i>
                <img v-else src="@/assets/images/right.png" alt="right-arrow" />
              </div>
              <div class="load-box" v-if="loading">
                <span class="loader"></span>
              </div>
              <div class="load-box" v-else-if="!loading && !resultList.length">
                No data.
              </div>
            </div>
        </div>
        <h2 class="banner-desc">
          <span style="color: #00ca69">Login</span> | for your recent address
        </h2>
      </div>
    </section>
    <section class="cuisines-box">
      <h2 class="cuisines-title">Our Famous <span>Cuisines</span></h2>
      <p class="cuisines-desc">
        Treat your taste buds with a variety of yummy food. Choose from Chinese
        to Indian, Pizza to Thai. Download the All Eat App and explore a vast
        range of <br />
        food menus with just a click of a button.
      </p>
      <div class="fake-indicate"></div>
      <p class="cuisines-desc" style="margin-top: 10px">
        Order Delicious food on All Eat
      </p>
      <!-- swiper 部分 -->
      <swiper :options="swiperOption" ref="mySwiper" id="mySwiper">
        <swiper-slide class="swiper_slide_item" v-for="item in foodTypeList" :key="item.cuisineId">
          <img
            :src="item.featuredImage"
            alt="alleat"
          />
        </swiper-slide>

        <!-- 可选的控件 -->
        <!--分页器-->
        <div class="swiper-pagination" slot="pagination"></div>

        <!--前进后退按钮-->
        <div class="swiper-button-prev" slot="button-prev"></div>
        <div class="swiper-button-next" slot="button-next"></div>
      </swiper>
    </section>

    <section class="download-box">
      <div class="desc-box">
        <h2 class="download-title">
          Download Free <br />
          <span style="color: #00ca69">All</span>
          <span style="color: #9300bb">Eat</span>
          App
        </h2>
        <p class="download-desc">
          Discover the best gourmet cuisines with <br />
          thousands of takeaway menus offering <br />
          the best discounts in the UK.
        </p>
        <div class="download-btn-box" >
          <a class="btn" href="https://play.google.com/store/apps/details?id=io.dcloud.uniAllEat&gl=GB">
            <img src="@/assets/images/google_download.png" alt="andriod">
          </a>
          <a class="btn" href="https://apps.apple.com/gb/app/all-eat-food-delivery-uk/id1603420846">
            <img src="@/assets/images/ios_download.png" alt="ios">
          </a>
        </div>
      </div>
      <div class="img-box">
        <img
          src="https://alleatapp.net/wp-content/uploads/2022/11/Black-and-Yellow-Modern-Food-Delivery-Facebook-Ad-e1668684213847.jpg"
          width="579"
          height="627"
          alt="alleat"
        />
      </div>
    </section>

    <section>
      <AllEatInfoBox :videoCode="pageConfig.indexVideoCode" :info="pageConfig"></AllEatInfoBox>
    </section>

    <section>
      <BenefitBox></BenefitBox>
    </section>

    <section>
      <AllEatDescBox></AllEatDescBox>
    </section>

    <!-- 回到顶部按钮 -->
    <el-backtop :bottom='128' :right='60'>
      <i class="el-icon-caret-top"></i>
    </el-backtop>

  </div>
</template>
<script>
import { postGateway } from '@/request';
import debounce from "@/utils/debounce.js";
import AllEatInfoBox from '@/components/IndexComps/AllEatInfoBox.vue'
import AllEatDescBox from '@/components/IndexComps/AllEatDescBox.vue'
import BenefitBox from '@/components/IndexComps/BenefitBox.vue'
export default {
  components: {
    AllEatInfoBox,
    AllEatDescBox,
    BenefitBox
  },
  // 页面级 meta 配置
  metaInfo() {
    return {
      meta: this.metaList,
      title: "Order takeaway Delivery online from 5,000+food Takeaway Near me delivery restaurants. | All Eat App - Food Delivery",
    };
  },
  name: "Index",
  data() {
    return {
      indexData: {
        url: "",
      },
      itemLoading: '',
      metaList: [{ name: "keywords", content: "这是index 首页" }],
      loading: true,
      resultList: [],
      pageConfig: {
        sitePhone: "",
        specialPhoto: "",
        searchPhoto: "",
      },
      keywords: "",
      foodTypeList: [],
      swiperOption: {
        //幻灯片放映方向
        direction: "horizontal", //通常不与左右按钮一同使用
        slidesPerView: 4,
        spaceBetween: 50,
        //分页器配置项
        pagination: {
          el: ".swiper-pagination", //分页器的类名
          clickable: true, // 点击分页器跳切换到相应的幻灯片
          bottom: 0,
        },
        //前进后退按钮
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        //幻灯片播放配置项
        loop: true, //是否循环播放
        speed: 1000, // 发生页面切换动画时，动画的切换速度
        autoplay: {
          delay: 3000, // 幻灯片停留时间
          disableOnInteraction: false, // 用户操作swiper之后，是否禁止autoplay
          stopOnLastSlide: true, // 切换到最后一个slide时是否停止自动切换。（loop模式下无效）。
        },
        breakpoints: {
          1024: {
            slidesPerView: 4,
            spaceBetween: 40,
          },
          768: {
            slidesPerView: 3,
            spaceBetween: 30,
          },
          640: {
            slidesPerView: 2,
            spaceBetween: 20,
          },
          320: {
            slidesPerView: 1,
            spaceBetween: 10,
          },
        },
        on: {
          slideChangeTransitionEnd: function () {
            // console.log(this.activeIndex); //每次切换结束时，在控制台打印现在是第几个slide
          },
        },
      },
    };
  },
  created() {
    this.getPageConfig();
    this.getSeoConfig();
    this.getFoodTypeList()
  },
  // 被缓存再次进入调用
  activated() {

  },
  methods: {
    onSwiper() {},
    onSlideChange() {},
    getPageConfig() {
      this.$postGateway({
        method: "GET",
        url: "/sysSetting/get",
        data: {},
      })
        .then(({ data }) => {
          this.pageConfig = data;
          console.log("首页config", data);
        })
        .catch(() => {});
    },
    getSeoConfig() {
      this.$postGateway({
        method: "GET",
        url: "/seoSetting/getAllEat",
        data: {},
      })
        .then(({ data }) => {
          console.log("首页seo", data);
        })
        .catch(() => {});
    },
    getFoodTypeList() {
      postGateway({
        url: '/customerWeb/index/popularCategory',
        method: 'GET',
        data: {}
      }).then(res=>{
        this.foodTypeList = res.data
        console.log(res,'res')
      })
    },
    inputNow() {
      this.resultList = [];
      this.loading = true;
      debounce(() => {
        if (this.keywords.trim().length < 3){
          this.loading = false;
          return
        }
        this.$postGateway({
          method: "GET",
          url: "/customerApp/index/getPreKeyword",
          data: { keyword: this.keywords },
        })
          .then((res) => {
            if (res.data.length) {
              this.resultList = res.data.map((x) => {
                return {
                  content: x,
                  type: "content",
                };
              });
              this.loading = false;
            } else {
              this.googlePreSearch();
            }
          })
          .catch(() => {
            this.googlePreSearch();
          });
      }, 500);
    },
    googlePreSearch() {
      this.$postGateway({
        method: "GET",
        url: "/customerWeb/googleSearch/autocomplete",
        data: { keyword: this.keywords },
      })
        .then((res) => {
          this.resultList = this.resultList.concat(
            res.data.predictions.map((x) => {
              return {
                ...x,
                content: x.description,
                type: "location",
              };
            })
          );
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    // 根据结果跳转页面
    normalSearch(item) {
      if (item.type == "content") {
        this.$router.push({
          path: "/browse",
          query: {
            searchName: item.content,
            lng: "",
            lat: "",
            searchLoc: "",
          },
        });
      } else if (item.type == "location") {
        this.googleSearch(item);
      }
    },
    googleSearch(item) {
      this.itemLoading = item.place_id;
      this.$postGateway({
        method: "GET",
        url: "/customerWeb/googleSearch/placeGeoCode",
        data: {
          keyword: "",
          placeId: item.place_id,
        },
      }).then((res) => {
        this.itemLoading = '';
        if (res.code == 200) {
          this.$router.push({
            path: "/browse",
            query: {
              searchName: "",
              lng: res.data.lng,
              lat: res.data.lat,
              searchLoc: res.data.formattedAddress,
              transType: this.transType,
            },
          });
          this.searchVisible = false;
        } else {
          this.$message.error("Error happen...");
        }
      }).catch(err=>{
        this.itemLoading = '';
        console.log(err,'err')
      })
    },
  },
};
</script>
<style lang="scss">
.index {

  .el-icon-caret-top {
    color: #409eff;
  }

  .banner-box {
    width: 100%;
    height: 702px;
    background-position: 50%;
    background-size: cover;
    background-color: #f8f8f8;

    .search-block {
      padding: 20px;
      position: relative;
      margin: 0 auto;
      top: 250px;
      min-height: 342px;
      max-width: 1180px;

      .banner-title {
        color: #ffffff;
        font-family: "Roboto", Sans-serif;
        font-size: 34px;
        font-weight: 600;
        letter-spacing: 1px;
        word-spacing: 0px;
        text-shadow: 0px 0px 10px #000000;
      }

      .banner-desc {
        color: #ffffff;
        font-family: "Roboto", Sans-serif;
        font-weight: 600;
        -webkit-text-stroke-color: #000;
        stroke: #000;
        text-shadow: 0px 0px 10px #000000;
      }

      .search-box {
        height: 50px;
        margin-top: 22px;
        display: flex;
        position: relative;
        input {
          font-family: "Roboto", Sans-serif;
          font-size: 20px;
          font-weight: 400;
          flex: 1;
          color: #8c8d8e;
          fill: #000000ad;
          padding-left: 20px;
          border-radius: 22px 0 0 22px;
          background: #eceeef;
        }

        .search-btn {
          transition: all 0.2s ease-in-out 0s;
          border-radius: 0 22px 22px 0;
          background: #27d07c;
          width: 110px;
          display: flex;
          justify-content: center;
          align-items: center;
          img {
            height: 20px;
            width: 20px;
          }
          &:hover {
            background: #049d51;
            color: #e8e4e4;
          }
        }

        .expand-box {
          position: absolute;
          width: 90%;
          height: 0px;
          top: 50px;
          left: 12px;
          background: rgba(255, 255, 255, 0.95);
          padding: 20px 0;
          height: 0px;
          opacity: 0;
          transition: all 0.8s ease-in-out 0s;

          .search-item {
            height: 50px;
            display: flex;
            align-items: center;
            border-bottom: 1px solid #e9e9e9;
            padding: 0 20px;
            cursor: pointer;

            .el-icon-loading {
              font-size: 18px;
              color: #aa0bc0;
              font-weight: bold;
            }

            &:hover {
              background-color: rgba(236, 230, 230, 0.95);
            }

            span {
              flex: 1;
            }

            img {
              height: 18px;
              width: 25px;
            }
          }
        }

        .load-box {
          height: 100%;
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          .loader {
            width: 48px;
            height: 48px;
            border: 5px solid #fff;
            border-bottom-color: #ff3d00;
            border-radius: 50%;
            display: inline-block;
            box-sizing: border-box;
            animation: rotation 1s linear infinite;
          }

          @keyframes rotation {
            0% {
              transform: rotate(0deg);
            }
            100% {
              transform: rotate(360deg);
            }
          }
        }

        .expand-box-active {
          height: 300px;
          opacity: 1;
          overflow-y: scroll;
        }

      }
    }
  }

  .cuisines-box {
    height: 640px;
    padding-top: 20px;
    box-sizing: border-box;
    background: #f7f9fb;
    .cuisines-title {
      text-align: center;
      color: #000000;
      text-shadow: 0px 0px 10px rgb(0 0 0 / 30%);
      margin: 0px 0px 17px 0px;
      font-family: "Roboto", Sans-serif;
      font-size: 36px;
      font-weight: 700;

      span {
        font-family: "Playfair Display", Sans-serif;
        font-size: 36px;
        font-weight: 700;
        font-style: italic;
        color: #aa0bc0;
        text-shadow: 0px 0px 0px rgb(0 0 0 / 30%);
        transition: all .3s ease;

        &:hover {
          color: #c028a3;
        }
      }
    }

    .cuisines-desc {
      margin-top: 30px;
      color: #565656;
      font-family: "Roboto", Sans-serif;
      font-size: 16px;
      font-weight: 400;
      line-height: 26px;
      text-align: center;
    }

    .fake-indicate {
      height: 4px;
      position: relative;
      width: 30px;
      background: #2575fc;
      border-radius: 2px;
      margin: 0 auto;
      margin-top: 30px;
      left: 15px;
      &::after {
        content: "";
        position: absolute;
        color: #0c5adb;
        left: -27px;
        top: 0;
        display: inline-block;
        height: 4px;
        width: 4px;
        border-radius: 50%;
        background-color: #0c5adb;
        -webkit-box-shadow: 9px 0 0 0 currentColor, 18px 0 0 0 currentColor;
        box-shadow: 9px 0 0 0 currentColor, 18px 0 0 0 currentColor;
      }
    }
  }

  .download-box {
    background: #fff;
    display: flex;

    .desc-box {
      height: 100%;
      width: 53%;
      text-align: center;
      padding-top: 50px;

      .download-title {
        color: #000000;
        text-shadow: 0px 0px 10px rgb(0 0 0 / 30%);
        margin: 0px 0px 25px 0px;
        font-family: "Roboto", Sans-serif;
        font-size: 66px;
        font-weight: 700;
        line-height: 67px;
        margin-top: 0px;
      }

      .download-desc {
        color: #030000;
        font-family: "Poppins", Sans-serif;
        font-size: 25px;
        font-weight: 400;
        line-height: 27px;
        margin-top: 20px;
      }
      .download-btn-box {
        height: 75px;
        width: 500px;
        margin: 20px auto;
        display: flex;
        justify-content: space-around;

        .btn {
          flex: 1;
          height: 75px;
          width: 240px;
          &:nth-child(1) {
            margin-right: 20px;
          }

          img {
            height: 100%;
            width: 240px;
          }
        }

      }
    }

    .img-box {
      height: 100%;
      width: 46%;
      text-align: center;

      img {
        width: 73%;
        height: auto;
      }
    }
  }
}

#mySwiper {
  min-height: 250px;
  max-width: 1120px;
  padding: 35px 10px 80px;
}

.swiper-slide.swiper_slide_item {
  background: #fff;
  border-radius: 25px 25px 25px 25px;
  overflow: hidden;
  box-shadow: 5px 10px 15px 0px rgba(0, 0, 0, 0.1);

  img {
    height: 250px;
    width: 250px;
  }
}
.swiper-button-prev,
.swiper-button-next {
  height: 40px;
  width: 34px;
  background: #e7e7e7;
  top: 40%;
}


.swiper-button-prev:after, .swiper-button-next:after {
  font-size: 14px!important;
  color: rgba(0,0,0,0.5);
}

</style>
